__cw__define(['jquery'], function ($) {
  "use strict";

  /*** fonctions publiques == */
  var init = function init(scope) {
    var scope = scope || "body";
    var ogTitle = $("meta[property='og:title']").attr("content");
    var ogDescription = $("meta[property='og:description']").attr("content");
    if ($("meta[property='og:image']").length) {
      var ogImage = $("meta[property='og:image']").attr("content").replace("http://", "");
    }
    var currentUrl = $(location).attr('href').replace("http://", "");
    var currentUrlLinkedIn = currentUrl.replace("/", "%2F");
    var lienFacebook = "https://www.facebook.com/sharer/sharer.php?u=" + currentUrl;
    var lienTwitter = "https://twitter.com/intent/tweet?url=" + currentUrl;
    var lienLinkedIn = "http://www.linkedin.com/sharing/share-offsite/?url=" + currentUrl;
    $(scope + " .partage-facebook").attr("href", lienFacebook);
    $(scope + " .partage-twitter").attr("href", lienTwitter);
    $(scope + " .partage-linkedin").attr("href", lienLinkedIn);
  };
  return {
    init: init
  };
});